import { FC, useEffect, useMemo, useState } from "react";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import cn from "classnames";
import styles from "./NoCard.module.sass";
import {userAPI} from "../../../../libs/apiClient/User";

const deps = ["system.employee.create", "system.employee.user_bind", "system.user.employee_bind", "system.user.create"];

const NoCard: FC = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const query = useParams();

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [params, setParams] = useState<{
		userid: string | undefined;
		employeeid: string | undefined;
	}>({
		userid: "",
		employeeid: "",
	});

	const [rulesNoCard, setRulesCard] = useState({
		user: {
			connect: false,
			create: false,
		},
		employee: {
			connect: false,
			create: false,
		},
	});

	const isUserPage = useMemo(() => {
		return /^\/user/.test(location.pathname);
	}, [location.pathname]);

	useEffect(() => {
		if (isUserPage) {
			setParams((prevState) => ({ ...prevState, userid: query?.userId }));
		} else {
			setParams((prevState) => ({
				...prevState,
				employeeid: query?.employeeId,
			}));
		}
		//eslint-disable-next-line
	}, [isUserPage]);

	useEffect(() => {
		userAPI.permissionsCheckCreate(0, deps).then(({ data }) => {
			setRulesCard({
				user: {
					connect: !data.includes("system.user.employee_bind"),
					create: !data.includes("system.user.create"),
				},
				employee: {
					connect: !data.includes("system.employee.user_bind"),
					create: !data.includes("system.employee.create"),
				},
			});
		});
	}, []);

	const disabled = useMemo(() => {
		return isUserPage ? rulesNoCard.user : rulesNoCard.employee;
	}, [isUserPage, rulesNoCard]);

	return (
		<div className={styles.content}>
			<div className={cn(styles.title, styles.contentTitle)}>
				Карточка {isUserPage ? "сотрудника" : "пользователя"} не подключена
			</div>
			<div className={styles.buttons}>
				<Button
					onClick={() => {
						navigate(isUserPage ? "/references/staff/select" : "/references/users/select", {
							state: { id: query.userId ? query.userId : query.employeeId },
						});
					}}
					disabled={disabled.connect}
					className={styles.button}>
					Подключить
				</Button>
				<Button
					onClick={() => {
						navigate(isUserPage ? "/references/staff" : "/references/users", {
							state: {
								from: isUserPage ? "employee" : "user",
							},
						});
					}}
					disabled={disabled.create}
					className={styles.button}
					variant={BUTTON_VARIANTS.OUTLINED}>
					Создать
				</Button>
			</div>
		</div>
	);
};

export default NoCard;
